import Vuex from 'vuex';
Vue.use(Vuex);
import createPersistedState from 'vuex-persistedstate'

const store = new Vuex.Store({
    plugins: [createPersistedState()],
    state: {
        isLoading: true,
        columnList: [],
        hiddenColumnList: []
    },
    mutations: {
        updateLoadingStatus (state, payload) {
            state.isLoading = payload
        },
        updateColumnList (state, obj) {
            state.columnList = obj
        },
        updateHiddenColumnList (state, obj) {
            state.hiddenColumnList = obj
        },
    },
    actions: {
        
    },

})


export default store



// WEBPACK FOOTER //
// ./src/store/store.js